var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVitality(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4007_296)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4007_296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0776 41.9999H11.922C11.4488 41.9999 10.9949 41.812 10.6603 41.4773C10.3257 41.1427 10.1377 40.6889 10.1377 40.2157V4.68076C10.1377 4.20754 10.3257 3.7537 10.6603 3.41909C10.9949 3.08447 11.4488 2.89648 11.922 2.89648H30.0776C30.5508 2.89648 31.0046 3.08447 31.3392 3.41909C31.6738 3.7537 31.8618 4.20754 31.8618 4.68076V40.2157C31.8618 40.6889 31.6738 41.1427 31.3392 41.4773C31.0046 41.812 30.5508 41.9999 30.0776 41.9999Z",
    fill: "#424A60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3789 0H24.6203V2.89655H17.3789V0Z",
    fill: "#D8A852"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0686 21.0003H23.172V11.6357C23.1807 11.5937 23.1257 11.5691 23.0996 11.6024L15.9307 23.1727H19.5514L19.5528 33.2592C19.5412 33.3019 19.5963 33.3295 19.6238 33.2954L26.0686 21.0003Z",
    fill: "#EFCE4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0776 2.89648H11.922C11.4488 2.89648 10.9949 3.08447 10.6603 3.41909C10.3257 3.7537 10.1377 4.20754 10.1377 4.68076V9.41373H31.8618V4.68076C31.8618 4.20754 31.6738 3.7537 31.3392 3.41909C31.0046 3.08447 30.5508 2.89648 30.0776 2.89648Z",
    fill: "#EA6248"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4007_296"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4007_296"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVitality);
export default __webpack_public_path__ + "static/media/vitality.b95dc81b1ba9b0c57e3c9ea962041ae3.svg";
export { ForwardRef as ReactComponent };